import { useFormController } from "./useFormController.ts";

/**
 * Hook providing access to the "submitting" status of a form in context.
 *
 * @returns Whether the form in context is being submitted.
 * @throws {NoFormContextError} When no form is in context.
 */
export function useSubmitting(): boolean {
  return useFormController().useSubmitting();
}
